import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "@/core/services/store";
import JwtService from "@/core/services/jwt.service";
import { ENV } from "@/core/config/env";
import {PURGE_SESSION, getSCRFToken, getCsrfRandom} from "@/core/services/store/auth.module";

/**
 * Service to call HTTP request via Axios
 */
 class apiService {
  $http = null;
  $baseURL = null;

  init = (options) => {
		options = options || {};
		const baseURL = options.url ? options.url : ENV.API_URL;
		Vue.use(VueAxios, axios);
		/*
		if (ENV.API_MODE === 'json') {
			Vue.axios.defaults.baseURL = window.location.origin;
		} else {
			Vue.axios.defaults.baseURL = baseURL;
		}
		*/
		//Vue.axios.defaults.baseURL = baseURL;
		this.$baseURL = baseURL;
		this.$http = Vue.axios;
		this.$http.defaults.baseURL = baseURL;
        this.$http.interceptors.response.use((response) => {
            if (response && response.data && response.data.code === 401) {
                store.dispatch(PURGE_SESSION);
                setTimeout(function () {
                  location.reload()
                }, 500);
                return
            }
            return response
        })
  };

  /**
   * Set the default HTTP request headers
   */
   setHeader = (token) => {
    this.$http.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${token ? token : JwtService.getToken()}`;
    this.$http.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  };

  setHeaderToken = (token) => {
    this.$http.defaults.headers.common["x-csrf-token"] = token;
  }

  ensureHasHeaderToken = () => {
    if( !getSCRFToken || this.$http.defaults.headers.common["x-csrf-token"] ){
      return;
    }
    this.$http.defaults.headers.common["x-csrf-token"] = getSCRFToken()
  }

  query = (resource, params) => {
	const options = this._getOptions();
    return this.$http.get(resource, params, options).catch(error => {
      // console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  };

  verifyPayload= (params) => {
    const csrf_token = getCsrfRandom(); 
    if( typeof params === 'undefined'){
      params = {_csrf:csrf_token}
    } else if( !params._csrf){
      params._csrf = csrf_token
    }
    return params;
  }

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  get = (resource, slug="", payload = {}) => {
    const url = this._getUri(resource, slug);
	  const options = this._getOptions(payload);
    this.ensureHasHeaderToken()
    return this.$http.get(`${url}`, options).catch(error => {
      console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  };

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
	post = (resource, params, payload) => {
		const options = this._getOptions(payload);
    this.ensureHasHeaderToken()
    params = this.verifyPayload(params)
		return this.$http.post(`${resource}`, params, options);
	};

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update = (resource, slug, params, payload) => {
    const options = this._getOptions(payload);
    this.ensureHasHeaderToken()
    params = this.verifyPayload(params)
    return this.$http.put(`${resource}/${slug}`, params, options);
  };

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put = (resource, params, payload) => {
    const options = this._getOptions(payload);
    this.ensureHasHeaderToken()
    params = this.verifyPayload(params)
    return this.$http.put(`${resource}`, params, options);
  };

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete = (resource, payload) => {
    const options = this._getOptions(payload);
    this.ensureHasHeaderToken()
    params = this.verifyPayload(params)
    return this.$http.delete(resource, options).catch(error => {
      // console.log(error);
      throw new Error(`[RWV] ApiService ${error}`);
    });
  };
  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
   _getUri = (resource, slug="") => {
		let uri = (slug != "" && slug !== undefined ) ? `${resource}/${slug}` : resource;
		if (ENV.API_MODE === 'json') {
			uri = '/json/' + `${uri}` + '.json';
		}
		return uri;
   };
   /**
   * get config option, baseURL
   * @param resource
   * @returns {*}
   */
	_getOptions = (payload) => {
		let options = payload || {};
		if (!options.baseURL ) {
			options.baseURL = this.$baseURL;
		}

		return options;
   };
};

// create instance
const ApiService = new apiService();
ApiService.init();
// lock instance
Object.freeze(ApiService);

export default ApiService;
